import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy
} from '@angular/core';
import {
  OsusumePlanManage,
  OsusumeCategoryList
} from '../../models/plan/osusume';
import { OsusumeService } from '../../services/osusume.service';
import { PlanMainService } from '../../plan/service/plan-main.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import { Subject } from 'rxjs/Rx';
import { DataService } from '../../services/data.service';
@Component({
  selector: 'app-osusume-setting',
  templateUrl: './osusume-setting.component.html',
  styleUrls: ['./osusume-setting.component.css']
})
export class OsusumeSettingComponent implements OnInit, OnDestroy {
  public kyotenCd: string;
  public listPlan: OsusumePlanManage[];
  public listCategory = [];
  public isLoading = true;
  public isNodata = false;
  public categoryNo = 1;
  public showCategoryDialog = false;
  public showEditDialog = false;
  public ngUnsubscribe = new Subject();
  public currentUrl:string = '';
  @Output('close') close: any = new EventEmitter();
  constructor(
    private osusumeSv: OsusumeService,
    private planMainService: PlanMainService,
    private router: Router,
    private dragulaService: DragulaService,
    private _data: DataService
  ) {
    dragulaService.setOptions('osusume', {
      removeOnSpill: false
    });

    dragulaService.drag.takeUntil(this.ngUnsubscribe).subscribe(value => {
      this.onDrag(value.slice(1));
    });
    dragulaService.drop.takeUntil(this.ngUnsubscribe).subscribe(value => {
      this.onDrop(value.slice(1));
    });
    dragulaService.over.takeUntil(this.ngUnsubscribe).subscribe(value => {
      this.onOver(value.slice(1));
    });
    dragulaService.out.takeUntil(this.ngUnsubscribe).subscribe(value => {
      this.onOut(value.slice(1));
    });
    dragulaService.dropModel.takeUntil(this.ngUnsubscribe).subscribe(value => {
      this.dropModel();
    });
  }

  ngOnInit() {
    this.kyotenCd = this._data.kyotenCd;
    this.currentUrl = this.router.url;
    this.getTemplate(1);
  }

  IsHeadquarter() {
    return this.categoryNo == null;
  }

  onChangePlanName(categoryNo) {
    this.categoryNo = categoryNo;
    this.getTemplate(categoryNo);
  }

  getTemplate(categoryNo) {
    this.isLoading = true;
    this.isNodata = false;
    this.osusumeSv
      .getplanTemplates(this.kyotenCd, categoryNo, true)
      .subscribe((data: OsusumePlanManage[]) => {
        this.isLoading = false;
        if (data) {
          this.listPlan = data;
        } else {
          this.isNodata = true;
          this.listPlan = null;
        }
      });
  }

  IsEnable(enabled: number) {
    return enabled === 1;
  }

  changeEnable(plan: OsusumePlanManage) {
    if (plan.enabled === 1) {
      plan.enabled = 0;
    } else {
      plan.enabled = 1;
    }

    const isHq = this.IsHeadquarter();
    this.osusumeSv.setEnable(plan.id, plan.enabled, isHq).subscribe(
      isSuccess => {
        if (!isSuccess) {
          this.onError();
        }
      },
      err => {
        // this.onError();
        if (err.status) {
          alert(err.message);
        } else {
          if (Number(err.rsltCode.substr(1, 4)) >= 500) {
            alert('システムエラーが発生しました。');
          } else if (Number(err.rsltCode.substr(1, 4)) >= 400) {
            alert(err.rsltComment);
          }
        }
      }
    );
  }

  createPlan(mitsumoriNo) {
    this.planMainService.isOsusume = true;
    setTimeout(() => {
      this._data.saveData('osusumeNo', mitsumoriNo);
      this._data.saveData('categoryNo', this.categoryNo.toString());
    }, 1000);
    this.router.navigate(['/planmain/osusume', mitsumoriNo]);
  }

  removePlan(id) {
    const isHq = this.IsHeadquarter();
    this.osusumeSv.removePlan(id, isHq).subscribe(
      isSuccess => {
        if (this.listPlan != null) {
          const index = _.findIndex(this.listPlan, function(o: any) {
            return o.id === id;
          });
          if (index > -1) {
            this.listPlan.splice(index, 1);
          }
        }
      },
      err => {
        // this.onError();
        if (err.status) {
          alert(err.message);
        } else {
          if (Number(err.rsltCode.substr(1, 4)) >= 500) {
            alert('システムエラーが発生しました。');
          } else if (Number(err.rsltCode.substr(1, 4)) >= 400) {
            alert(err.rsltComment);
          }
        }
      }
    );
  }

  addPlanName() {
    this.showCategoryDialog = true;
  }

  onCloseCategoryDialog() {
    this.showCategoryDialog = false;
  }

  onClose() {
    this.close.emit();
    if (this.currentUrl === '/osusume') {
      // location.reload();
      this.osusumeSv.reLoadOsusume.next(true);
    }
  }

  editPlanName() {
    this.showEditDialog = true;
  }

  onClseEditDialog() {
    this.showEditDialog = false;
  }

  hasClass(el: any, name: string): any {
    return new RegExp('(?:^|\\s+)' + name + '(?:\\s+|$)').test(el.className);
  }

  addClass(el: any, name: string): void {
    if (!this.hasClass(el, name)) {
      el.className = el.className ? [el.className, name].join(' ') : name;
    }
  }

  removeClass(el: any, name: string): void {
    if (this.hasClass(el, name)) {
      el.className = el.className.replace(
        new RegExp('(?:^|\\s+)' + name, 'g'),
        ''
      );
    }
  }

  onDrag(args: any) {
    let [el] = args;
    this.removeClass(el, 'ex-moved');
  }

  onDrop(args: any) {
    let [el] = args;
    this.addClass(el, 'ex-moved');
  }

  onOver(args: any) {
    let [el] = args;
    this.addClass(el, 'ex-over');
  }

  onOut(args: any) {
    let [el] = args;
    this.removeClass(el, 'ex-over');
  }

  dropModel() {
    let arr = this.listPlan.map(obj => {
      return obj.id;
    });
    this.osusumeSv
      .changePlanOrder(arr, this.kyotenCd, this.categoryNo)
      .subscribe(
        isSuccess => {
          if (!isSuccess) {
            this.onError();
          }
        },
        err => {
          // this.onError();
          if (err.status) {
            alert(err.message);
          } else {
            if (Number(err.rsltCode.substr(1, 4)) >= 500) {
              alert('システムエラーが発生しました。');
            } else if (Number(err.rsltCode.substr(1, 4)) >= 400) {
              alert(err.rsltComment);
            }
          }
        }
      );
  }

  onError() {
    this.onError();
  }

  ngOnDestroy() {
    this.dragulaService.destroy('osusume');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/osusume/osusume-setting/osusume-setting.component.ts